// src/pages/ProfileDetailPage.tsx
// Halaman profil detail dengan semua komponen

import React from "react";
import ProfileHeader from "../components/profile/ProfileHeader";
import AchievementGrid from "../components/profile/AchievementGrid";
import EducationHistory from "../components/profile/EducationHistory";
import CourseHistory from "../components/profile/CourseHistory";
import PhotoGallery from "../components/gallery/PhotoGallery";
import Navbar from "../components/Navbar";
import { useOptimizedProfile } from "../hooks/useOptimizedProfile";





const ProfileDetailPage: React.FC = () => {
    const { profileData } = useOptimizedProfile();

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Navigation */}
            <Navbar />

            {/* Main Content */}
            <main className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-8 pb-24 sm:pb-8">

                <div className="space-y-4 sm:space-y-8">
                    {/* Profile Header */}
                    <ProfileHeader />

                    {/* Achievement Grid */}
                    <div id="achievements">
                        <AchievementGrid />
                    </div>

                    {/* Education History */}
                    <div id="education">
                        <EducationHistory />
                    </div>

                    {/* Course History */}
                    <div id="courses">
                        <CourseHistory />
                    </div>



                    {/* Photo Gallery */}
                    <PhotoGallery />
                </div>
            </main>

            {/* Footer */}
            <footer className="bg-white border-t border-gray-200 mt-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="text-center text-gray-600">
                        <p>
                            &copy; {new Date().getFullYear()} Portfolio{" "}
                            {profileData?.fullName || "Loading..."}. Dibuat dengan
                            ❤️
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default ProfileDetailPage;
